import React, { useState } from 'react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { supabase } from '../utils/supabase-client';
import { projectId, publicAnonKey } from '../../../utils/supabase/info';

export const DebugSupabaseConfig: React.FC = () => {
  const [configResult, setConfigResult] = useState<any>(null);
  const [jwtTestResult, setJwtTestResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const checkBackendConfig = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `https://${projectId}.supabase.co/functions/v1/make-server-684c7e75/debug/config`
      );
      const data = await response.json();
      setConfigResult(data);
      console.log('🔍 Backend config:', data);
    } catch (error) {
      console.error('Failed to check config:', error);
      setConfigResult({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  const testJWTValidation = async () => {
    setLoading(true);
    try {
      // Get current session token
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session?.access_token) {
        setJwtTestResult({ error: 'No active session found. Please sign in first.' });
        setLoading(false);
        return;
      }

      console.log('🔍 Testing JWT with token length:', session.access_token.length);

      const response = await fetch(
        `https://${projectId}.supabase.co/functions/v1/make-server-684c7e75/debug/test-jwt`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${session.access_token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      const data = await response.json();
      setJwtTestResult({
        ...data,
        responseStatus: response.status,
        responseOk: response.ok
      });
      console.log('🔍 JWT test result:', data);
    } catch (error) {
      console.error('Failed to test JWT:', error);
      setJwtTestResult({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 space-y-6">
      <Card className="p-6">
        <h2 className="text-2xl font-bold mb-4">🔍 Supabase Configuration Debugger</h2>
        
        <div className="space-y-4">
          <div>
            <h3 className="font-semibold mb-2">Frontend Configuration:</h3>
            <pre className="bg-gray-100 p-4 rounded text-sm overflow-x-auto">
              {JSON.stringify({
                projectId,
                anonKeyPreview: publicAnonKey.substring(0, 30) + '...',
                anonKeyLength: publicAnonKey.length,
                supabaseUrl: `https://${projectId}.supabase.co`
              }, null, 2)}
            </pre>
          </div>

          <div className="flex gap-4">
            <Button onClick={checkBackendConfig} disabled={loading}>
              Check Backend Config
            </Button>
            <Button onClick={testJWTValidation} disabled={loading}>
              Test JWT Validation
            </Button>
          </div>

          {configResult && (
            <div>
              <h3 className="font-semibold mb-2">Backend Configuration:</h3>
              <pre className="bg-gray-100 p-4 rounded text-sm overflow-x-auto">
                {JSON.stringify(configResult, null, 2)}
              </pre>
            </div>
          )}

          {jwtTestResult && (
            <div>
              <h3 className="font-semibold mb-2">JWT Validation Test:</h3>
              <pre className={`p-4 rounded text-sm overflow-x-auto ${
                jwtTestResult.success ? 'bg-green-100' : 'bg-red-100'
              }`}>
                {JSON.stringify(jwtTestResult, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
};
